export default __webpack_public_path__ + "static/media/clock.26c3e9d2.svg";